import * as tokens from '@utmost.co/utmost-design-tokens';

// Component has custom CSS properties. Something to discus where and how these colors should be included.
export const sideNavBarCSS = {
  label: tokens.colorOnBackground,
  toggleButton: {
    background: '#fafafa',
    hoverBackground: '#d8d8d8',
    borderColor: tokens.colorSurfaceVariant
  },
  menuItem: {
    borderRadius: '50px!important'
  },
  divider: {
    background: tokens.colorSurfaceVariant
  }
} as const;
